import { atom } from 'recoil'

export const shrimpTransferDateTableFilterState = atom<Date | undefined>({
  key: 'shrimpTransferDateTableFilterState',
  default: undefined,
})

export const selectedShrimpTransferState = atom<number | undefined>({
  key: 'selectedShrimpTransferState',
  default: undefined,
})
